import { useMemo } from "react";
import useSWR from "swr";

import { organizationEndpoints } from "@api/Endpoints";
import { OrganizationDetails } from "@organization/models/OrganizationDetails";

import { fetcher } from "@utils/swrUtils";

export function useGetOrganizationById(organizationId: string) {
  const url = organizationId
    ? organizationEndpoints.organizationById(organizationId)
    : null;

  const { data, error, isLoading } = useSWR<OrganizationDetails, Error>(
    url,
    fetcher,
    { revalidateOnFocus: false }
  );

  return useMemo(
    () => ({ organization: data, isLoading, error }),
    [data, isLoading, error]
  );
}
